import React from "react";
import {
  FormControl,
  Form,
  ControlLabel,
  Col,
  Grid,
  Row,
} from "react-bootstrap";
import icon from "../../img/app_control.png";
import Manual from "../../Manual";
import { CLIENT_NAME, WORK_PLACE_ENDPOINT } from "../../utils/constants";

type VerifyFormProps = {
  scopes: string[];
  address: string;
  doSendEmail: () => Promise<void>;
  sendButtonDisable?: boolean;
};

function VerifyForm({
  scopes,
  address,
  doSendEmail,
  sendButtonDisable = false,
}: VerifyFormProps) {
  return (
    <Grid>
      <Col sm={12} className="App">
        <a href={WORK_PLACE_ENDPOINT + "/portal/admin-menu.html"} id="linkHome">
          Back to Top
        </a>
        <span> / </span>
        <a
          href={WORK_PLACE_ENDPOINT + "/portal/usrmgmt.html"}
          id="linkUserManagement"
        >
          Back to User Management
        </a>
        <div style={{ background: "#FFFFFF" }}>
          <h2>
            <img src={icon} className="top-menu-icon" />
            Google Workspace Directory Synchronization
          </h2>
          <Manual clientName={CLIENT_NAME} scopes={scopes.join(",")} />
          <div
            className="rsi-title"
            style={{ marginLeft: "15px", marginBottom: "0px" }}
          >
            <b>Step 6:</b> Confirm Google Workspace admin mail address
          </div>
          <Col
            sm={12}
            className="border border-secondary"
            style={{ background: "#FFFFFF", paddingBottom: "20px" }}
          >
            <Row>
              <p>
                To synchronize Google Workspace users, confirm your email
                address is the administrator email address of the Google
                Workspace domain.
                <br />
                It will be send mail to the following e-mail address registered
                as your e-mail address.
                <br />
                Since the URL of the synchronous execution page is described in
                the e-mail , click that.
                <br />
              </p>
            </Row>
            <Form horizontal>
              <Row>
                <Col componentClass={ControlLabel} sm={2}>
                  <label>mail address</label>
                </Col>
                <Col sm={10}>
                  <FormControl
                    type="text"
                    value={address}
                    disabled={true}
                    id="addressForm"
                  />
                </Col>
              </Row>
              <button
                className="rsi-button is-primary"
                type="button"
                id="sendButton"
                disabled={sendButtonDisable}
                onClick={() => {
                  doSendEmail();
                }}
              >
                Send E-mail
              </button>
            </Form>
          </Col>
        </div>
      </Col>
    </Grid>
  );
}

export default VerifyForm;
